import { HttpService } from '@/infra/http'

export type TGetPlantasBlocoResponse = Array<{
  id: string
  descricao: string
}>

export class GetPlantasBlocoService extends HttpService {
  execute = async (idExterno: number) => {
    return this.http.get<TGetPlantasBlocoResponse>(`/api/v2/Bloco/${idExterno}/plantas`)
  }
}
